module.exports = __webpack_public_path__ + "img/buchhaltung.d6926663.jpg";